<template>
  <Card class="i-content" :bordered="false" dis-hover>
    <div class="demo-split"  id="scrollview">
      <!-- 左边内容区 -->
      <div class="demo-split-left">
        <slot name="left" />
        <ButtonGroup vertical v-show="isMobile">
          <Button class="floatButton" size="small" type="primary" icon="ios-arrow-back" @click="value1 = true"></Button>
        </ButtonGroup>
      </div>
      <!-- 右边内容区 -->
      <div class="demo-split-right" v-show="!isMobile" >
        <!-- <Affix @on-change="change"> -->
        <slot name="search" v-if="!isMobile"/>
        <!-- </Affix> -->
      </div>
      <Drawer :closable="true" v-model="value1" v-show="isMobile" width="100">
        <slot name="serchmobile" v-if="isMobile"/>
      </Drawer>
    </div>
  </Card>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "SearDraw",
  data: () => ({
    value1: false,
    columns1: [
      {
        title: 'Name',
        key: 'name'
      },
      {
        title: 'Age',
        key: 'age'
      },
      {
        title: 'Address',
        key: 'address'
      }
    ],
    data1: [
      {
        name: 'John Brown',
        age: 18,
        address: 'New York No. 1 Lake Park',
        date: '2016-10-03'
      },
      {
        name: 'Jim Green',
        age: 24,
        address: 'London No. 1 Lake Park',
        date: '2016-10-01'
      },
      {
        name: 'Joe Black',
        age: 30,
        address: 'Sydney No. 1 Lake Park',
        date: '2016-10-02'
      },
      {
        name: 'Jon Snow',
        age: 26,
        address: 'Ottawa No. 2 Lake Park',
        date: '2016-10-04'
      }
    ]
  }),
  mounted () {
    // console.log("isMobile:"+this.isMobile)
  },
  computed: {
    ...mapGetters({
      isMobile: "getIsMobile"
    })
  },
  methods: {
    change(status) {
      this.$Message.info(`Status: ${status}`);
    },
  }
};
</script>
<style lang="postcss" scoped>
.i-content {
  min-height: calc(100vh - 174px);

& .i-search-bar {
    display: flex;
    justify-content: space-between;
  }

& .i-content {
    min-height: auto;

& .ivu-card-body {
    padding: 0;
  }
}

}

.demo-split {
  min-height: calc(100vh - 174px);
  display: -webkit-box;

& .demo-split-left {
    flex: 1;
  }

& .demo-split-right {
    position: sticky;
    top: 0px;
    width: 40%;
    margin-left: 20px;
  }
}

.floatButton {
  float: right;
  z-index: 1000;
  position: fixed;
  right: 0%;
  width: 20px;
  height: 60px;
  bottom: 40%;
}

/deep/ .ivu-btn>.ivu-icon {
  line-height: 1.5;
  font-size: 18px;
}

/deep/ .ivu-btn-group-vertical>.ivu-btn {
  min-width: 20px;
}
</style>
